import { render } from "./z-channel-subscribe.vue?vue&type=template&id=19ba6369&scoped=true"
const script = {}

import "./z-channel-subscribe.vue?vue&type=style&index=0&id=19ba6369&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ba6369"]])

export default __exports__